import { api, protectedApi } from '@api/index';
import { formatApiResponse } from '@utils/helpers';

/**
 * Clinic-managed notification settings - who receives this clinic's lead alerts.
 *
 * No clinic is ever named by the caller. The API takes it from the signed-in account and
 * ignores anything sent, so a request cannot reach another clinic's list.
 */

export async function getAlertTypesApi() {
  try {
    const res = await protectedApi.get('/notification/settings/alert-types/');
    return formatApiResponse(res);
  } catch (e) {
    console.error('getAlertTypesApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function getNotificationRecipientsApi() {
  try {
    const res = await protectedApi.get(
      '/notification/settings/recipients/'
    );
    return formatApiResponse(res);
  } catch (e) {
    console.error('getNotificationRecipientsApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function addNotificationRecipientApi(payload) {
  try {
    const res = await protectedApi.post(
      '/notification/settings/recipients/',
      payload
    );
    return formatApiResponse(res);
  } catch (e) {
    console.error('addNotificationRecipientApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function updateNotificationRecipientApi(recipientId, payload) {
  try {
    const res = await protectedApi.put(
      `/notification/settings/recipients/${recipientId}`,
      payload
    );
    return formatApiResponse(res);
  } catch (e) {
    console.error('updateNotificationRecipientApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function deleteNotificationRecipientApi(recipientId) {
  try {
    const res = await protectedApi.delete(
      `/notification/settings/recipients/${recipientId}`
    );
    return formatApiResponse(res);
  } catch (e) {
    console.error('deleteNotificationRecipientApi.catch', e);
    return formatApiResponse(e);
  }
}

export async function resendVerificationApi(recipientId) {
  try {
    const res = await protectedApi.post(
      `/notification/settings/recipients/${recipientId}/resend-verification/`,
      {}
    );
    return formatApiResponse(res);
  } catch (e) {
    console.error('resendVerificationApi.catch', e);
    return formatApiResponse(e);
  }
}

/**
 * Confirm an address from the link in the email.
 *
 * Unauthenticated on purpose: the person clicking is a clinic's staff member or shared
 * mailbox with no ForeverOne account. The signed token is the whole credential, which is
 * why this uses the plain client rather than the one that attaches a bearer token.
 */
export async function confirmNotificationEmailApi(token) {
  try {
    const res = await api.post('/notification/verify/', { token });
    return formatApiResponse(res);
  } catch (e) {
    console.error('confirmNotificationEmailApi.catch', e);
    return formatApiResponse(e);
  }
}
